import {
    FETCH_BOOKING_RESERVATIONS,
    FETCH_BOOKING_RESERVATIONS_FAILURE,
    FETCH_BOOKING_RESERVATIONS_SUCCESS,
    FETCH_BOOKING_RESERVATION_PRICES,
    FETCH_BOOKING_RESERVATION_PRICES_FAILURE,
    FETCH_BOOKING_RESERVATION_PRICES_SUCCESS,
} from 'store/actions/types';

export const fetchBookingReservations = (payload) => {
    return {
        type: FETCH_BOOKING_RESERVATIONS,
        payload: payload,
    };
};

export const fetchBookingReservationsFailure = (error) => {
    return {
        type: FETCH_BOOKING_RESERVATIONS_FAILURE,
        error: error,
    };
};

export const fetchBookingReservationsSuccess = (id, response) => {
    return {
        type: FETCH_BOOKING_RESERVATIONS_SUCCESS,
        id: id,
        response: response,
    };
};

export const fetchBookingReservationPrices = (payload) => {
    return {
        type: FETCH_BOOKING_RESERVATION_PRICES,
        payload: payload,
    };
};

export const fetchBookingReservationPricesFailure = (error) => {
    return {
        type: FETCH_BOOKING_RESERVATION_PRICES_FAILURE,
        error: error,
    };
};

export const fetchBookingReservationPricesSuccess = (response) => {
    return {
        type: FETCH_BOOKING_RESERVATION_PRICES_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/bookingReservations/fetchBookingReservations.js